import React from 'react';
import { toCurrency } from '../../i18n/currency';

export function SummaryCardCurrency(props: { children: number | null }) {
  let value = toCurrency(props.children ?? 0).replace('$', '');
  return <>${value}</>;
}
